module.exports = __webpack_public_path__ + "img/home_no-schedule.3eb55a62.png";